module.exports = __webpack_public_path__ + "img/course124.cce79813.png";